import Map from 'ol/Map';
import { showFeedbackDialog } from '../../components/feedbackDialog';
import { handleSendFeedback } from './handler';
import { ContactSettings } from '../../components/contactDetails';

let clickTimeout: number | undefined;

export interface FeedbackClickOptions {
    /** When false, thumbs up/down is hidden and the point is saved as neutral. */
    allowRating: boolean;
    /** When false, points are not drawn on the map after a response is saved. */
    showFeedbackToPublic: boolean;
    /** Optional contact fields in the popup - null when the dialog does not collect contact details. */
    contact?: ContactSettings | null;
}

export function registerFeedbackClick(map: Map, options: FeedbackClickOptions = { allowRating: true, showFeedbackToPublic: true }): void {
    map.on('click', (evt) => {
        // Delay single click
        if (clickTimeout) {
            clearTimeout(clickTimeout);
        }

        clickTimeout = window.setTimeout(async () => {
            const coord = evt.coordinate as [number, number];
            const epsg = map.getView().getProjection().getCode();

            // Hide mapInfoAlert if shown
            const mapInfoAlert = document.getElementById('mapInfoAlert');
            if (mapInfoAlert) {
                mapInfoAlert.classList.add('d-none');
            }

            const result = await showFeedbackDialog({ allowRating: options.allowRating, contact: options.contact ?? null });
            if (!result) return;

            await handleSendFeedback(coord, epsg, result.rating, result.comment, result.save, options.showFeedbackToPublic, result.contact);

            clickTimeout = undefined;
        }, 250); // wait in case a dblclick follows
    });

    map.on('dblclick', () => {
        if (clickTimeout) {
            clearTimeout(clickTimeout); // prevent feedback popup
            clickTimeout = undefined;
        }
        // let OL handle dblclick → zoom in
    });
}
